import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import {buildOptions, getEndPoint} from '../../../utils/api-call';
import {makeCall} from '../../../utils/request';

Vue.use(VueAxios, axios);

const actions = {
  ACTION_GET_SB_WORKGROUPS: ({commit}) => {
    let apiUrl = getEndPoint().shiftboard.getWorkgroups;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET')).then(response => {
        resolve(response);
        commit('MUTATION_UPDATE_SB_WORKGROUPS', response || []);
      })
    });
  }
};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/shiftboard/actions.js